import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-feedback-submit',
  templateUrl: './feedback-submit.component.html',
  styleUrls: ['./feedback-submit.component.scss']
})
export class FeedbackSubmitComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<FeedbackSubmitComponent>,) { }

  ngOnInit(): void {
  }



  onClose() {
    this._matDialogRef.close()
  }
}
